<xemex-card
  [title]="'installations.general.installationProfile' | translate"
  [fill]="true"
  [actionLabel]="canOpenDataSources() ? ('general.btnViewAll' | translate) : undefined"
  [actionIcon]="canOpenDataSources() ? 'arrow_forward' : undefined"
  (action)="openDataSources()"
>
  <div class="points">
    <div class="points__layout">
      <div class="points__profile">
        <div class="flex flex-col gap-1">
          <p class="points__name" data-testid="profile-name">
            {{ installation().profile?.presetName ?? ('installations.profile.custom' | translate) }}
            @if (installation().profile?.editedSincePreset) {
              <span class="points__edited">
                · {{ 'installations.profile.edited' | translate }}</span
              >
            }
          </p>

          @if (isLoading()) {
            <xemex-skeleton-block width="10rem" height="16px" />
          } @else if (!failed()) {
            <p class="m-0 text-sm text-text-secondary" data-testid="required-count">
              {{
                (rows().length === 1
                  ? 'installations.checklist.requiredOne'
                  : 'installations.checklist.required'
                ) | translate: { count: rows().length }
              }}
            </p>
          }
        </div>
      </div>

      <div class="points__table">
        <span class="points__label">{{ 'installations.general.points' | translate }}</span>
        @if (failed()) {
          <div class="flex flex-col items-start gap-2">
            <p class="m-0 text-text-error" role="alert">
              {{ 'installations.checklist.failed' | translate }}
            </p>
            <xemex-text-button icon="refresh" (click)="reload()">
              {{ 'installations.checklist.retry' | translate }}
            </xemex-text-button>
          </div>
        } @else if (!isLoading() && !rows().length) {
          <p class="m-0 text-text-secondary">{{ 'installations.checklist.empty' | translate }}</p>
        } @else {
          <xemex-table
            [data]="rows()"
            [columns]="columns()"
            [compact]="true"
            [pageable]="false"
            [showFooter]="false"
            [outlinedIcons]="true"
            [loading]="isLoading()"
          />
        }
      </div>
    </div>
  </div>
</xemex-card>
